import { ArrowLeft, ArrowRight, Loader2 } from 'lucide-react'
import { cn } from '@/utils/cn'

interface WizardNavigationProps {
  onBack?: () => void
  onContinue?: () => void
  onSubmit?: () => void
  canGoBack?: boolean
  canContinue?: boolean
  isLastStep?: boolean
  isSubmitting?: boolean
  continueLabel?: string
  submitLabel?: string
  backLabel?: string
}

export function WizardNavigation({
  onBack,
  onContinue,
  onSubmit,
  canGoBack = true,
  canContinue = true,
  isLastStep = false,
  isSubmitting = false,
  continueLabel = 'Continue',
  submitLabel = 'Create Plan',
  backLabel = 'Back',
}: WizardNavigationProps) {
  const handlePrimaryAction = () => {
    if (isLastStep && onSubmit) {
      onSubmit()
    } else if (onContinue) {
      onContinue()
    }
  }

  const primaryLabel = isLastStep ? submitLabel : continueLabel
  const isPrimaryDisabled = !canContinue || isSubmitting

  return (
    <div className="flex items-start justify-between">
      {/* Back button - always visible */}
      <button
        onClick={onBack}
        disabled={!canGoBack || isSubmitting}
        className={cn(
          'flex items-center justify-center gap-[8px]',
          'px-[25px] py-[9px] h-[44px]',
          'border border-[#556374] rounded-[8px]',
          'text-[14px] font-medium leading-[20px] text-[#556374]',
          'cursor-pointer transition-opacity',
          (!canGoBack || isSubmitting) && 'opacity-50 cursor-not-allowed'
        )}
      >
        <ArrowLeft className="h-[18px] w-[18px]" />
        {backLabel}
      </button>

      {/* Continue/Submit button */}
      {(onContinue || onSubmit) && (
        <button
          onClick={handlePrimaryAction}
          disabled={isPrimaryDisabled}
          className={cn(
            'flex items-center gap-[13px]',
            'px-[29px] py-[10px]',
            'bg-primary rounded-[8px]',
            'shadow-[0px_4px_6px_-1px_rgba(0,0,0,0.1),0px_2px_4px_-2px_rgba(0,0,0,0.1)]',
            'text-[16px] font-medium leading-[24px] text-white text-center',
            'cursor-pointer transition-opacity',
            isPrimaryDisabled && 'opacity-50 cursor-not-allowed'
          )}
        >
          {isSubmitting ? (
            <>
              <Loader2 className="h-[18px] w-[18px] animate-spin" />
              Creating...
            </>
          ) : (
            <>
              {primaryLabel}
              <ArrowRight className="h-[18px] w-[18px]" />
            </>
          )}
        </button>
      )}
    </div>
  )
}
